function buildProductUrl(host, routeUrl, handle) {
    if (routeUrl == '/') {
        return 'https://' + host + routeUrl + 'products/' + handle;
    }
    return 'https://' + host + routeUrl + '/products/' + handle;
}

window.addEventListener('load', function() {
    var productHandle = localStorage.getItem('currentProduct');
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var token = params.get('token');
    var settingId = params.get('setting_id');
    var settingName = params.get('setting_name');
    var memberId = params.get('member_id');
    var fcAuthError = params.get('fc_auth_error');

    if(token != null && settingId != null){
        localStorage.setItem(settingId, decodeURIComponent(token));

        var settingNo = settingId.match(/^setting(\d+)$/);
        localStorage.setItem('settingName' + settingNo[1], decodeURI(settingName));
        localStorage.setItem('memberId' + settingNo[1], memberId);
    }

    var route_url = localStorage.getItem('tci_route_url');

    if (fcAuthError === '1' && productHandle != null) {
        console.log('FC認証エラーリダイレクト発生');
        location.href = buildProductUrl(url.host, route_url, productHandle);
    } else if (productHandle != null && token !== null) {
        location.href = buildProductUrl(url.host, route_url, productHandle);
    } else if (!Shopify.designMode) {
        location.href = 'https://' + url.host;
    }
})
